import request from "../base-request";

export const getRbacPrimaryRolePermissions = async (objectType: string, targetCompanyId?: string) => {
	const params = new URLSearchParams({ object_type: objectType });
	if (targetCompanyId) params.set("company_id", targetCompanyId);
	const [data] = await request<{ user_permissions: string[]; [key: string]: any }>(
		`/api/rbac/permissions/?${params.toString()}`
	);
	return data.user_permissions;
};

export const getRbacObjectPermissions = async (objectType: string, objectId: string) => {
	const [data] = await request<{ user_permissions: string[]; [key: string]: any }>(
		`/api/rbac/permissions/objects/${objectType}/${objectId}`
	);
	return data.user_permissions;
};

export const getRbacEmployeePermissions = async (employeeID: string, objectType?: string) => {
	try {
		const [data] = await request<{ user_permissions: string[] }>(
			`/api/rbac/permissions/employee/${employeeID}${objectType ? `/?object_type=${objectType}` : ""}`
		);
		return data.user_permissions;
	} catch (error) {
		throw error;
		return [];
	}
};

export const getRbacCompanySettingDependentPermission = async (
	companySetting: string,
	objectType: string,
	permissionName: string,
	featureFlagName?: string
) => {
	try {
		let url = `/api/rbac/permissions/company-setting/${companySetting}/?object_type=${objectType}&permission_name=${permissionName}`;

		if (featureFlagName) {
			url += `&feature_flag=${featureFlagName}`;
		}

		const [data] = await request<{ user_has_permission: boolean }>(url);
		return data.user_has_permission;
	} catch (error) {
		throw error;
	}
};
